// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1Jyqh","cell":"ColumnAccessor_cell__1MRCa","firstCellAccent":"ColumnAccessor_firstCellAccent__3k06_"};